import { useLoggedInUser } from "Hooks/useLoggedInUser";

/**
 * Chat is IdentityUser-keyed — non-migrated users (no active IdentityUser) cannot chat yet.
 * The single gate both the desktop and the bottom menu use to show or hide the Chat entry.
 */
export const useIsChatCapable = () => {
  const user = useLoggedInUser();

  return user?.activeContextPublicID != null;
};
